import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FAQ = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to Help page where FAQs are located
        navigate('/help');
    }, [navigate]);

    return null;
};

export default FAQ;
